export default __webpack_public_path__ + "assets/4daa20a9290c2d5a056fef69a9f7d1f3.svg";